<template>
    <div>
        <navbar :title="text_title"></navbar>
        <div class="studies" v-if="ashow">
            <div v-for="item in arr_tb" :key="item.id" @click="infobtn(item)">
                <div class="left">
                    <img :src="item.cs_picture" alt="">
                </div>
                <div class="right">
                    <p>{{item.cs_name}}</p>
                    <p>{{item.cs_brief}}</p>
                    <p>
                        <span>{{item.sec_numbers}}课时</span> | <span>{{item.price_type}}人在学</span> 
                        <span>
                            <img src="@/assets/xioayalaoshi.png" alt="">
                        </span>
                        <span>
                            <img src="@/assets/xioayalaoshi.png" alt="">
                        </span>
                    </p>
                </div>
            </div>
        </div>
         <div v-else class="zanwu">暂无课程</div>
    </div>
</template>

<script>
import navbar from './Navbar'
import URL from '../api/index'
export default {
    components:{
        navbar
    },
    data(){
        return{
            arr_tb:[],
            ashow:true,
            grade_id:0,
            subgect_id:0,
            press_id:0,
            page_id:1,
            word:'',
            text_title:'',
            type:'',
            type_ys:9
        }
    },
    mounted(){
        this.aaa()
        this.list()
    },
    methods:{
        aaa(){
            this.top_id = this.$route.query.top_id;
            this.text_title = this.$route.query.text_title;
        },
        infobtn(item){
            this.$router.push({
                name:'newclassdetails',
                query:{
                    csid: item.id,
                    icoType: this.icoType,
                    icotype: '1',
                }
            })
        },
        list(){
            var that=this
            if(that.top_id == 239){
                that.type = that.type_ys
            }
            this.$axios({
                method:'post',
                url:URL.get_course_list,
                data:{
                    keywords:that.word,
                    top_id:that.top_id,
                    grade_id:that.grade_id,
                    subject_id:that.subgect_id,
                    press_id:that.press_id,
                    page:that.page_id,
                    type:that.type
                }
            }).then((res)=>{
                if(res.data.state==1){
                    that.ashow=false
                }else{
                    that.ashow=true
                }
                that.arr_tb = res.data.result
            })
        }

    }
}
</script>

<style scoped>
*{
    margin: 0;
    padding: 0;
}
.studies>div{
    margin-top: 15px;
    padding: 0 15px;
    display: flex;
    flex: 1;
    justify-content: space-between;
}
.studies .left{
    flex: 0.25;
    height: 95px;
}
.studies .left img{
    width: 100%;
    height: 100%;
    border-radius: 5px;
}
.studies .right{
    flex:0.71;
}
.studies .right p:first-child{
    font-size: 16px;
    margin-bottom: 10px;
}
.studies .right p:nth-child(2){
    font-size: 12px;
    color: #a5a689;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
    overflow:hidden;
    margin-bottom: 15px;
}
.studies .right p:nth-child(3){
    font-size: 12px;
    color: #a5a689;
}
.studies .right p:nth-child(3) span:first-child{
    color: #5583ec;
}
.studies .right p:nth-child(3) span img{
    width: 20px;
    vertical-align: middle;
    float: right;
    border-radius: 10px;
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/studies.vue